(function () {
  var consultationBookingUrl = 'https://www.drsknn.uk/kiosk?tab=consultations';
  var treatmentBookingUrl = 'https://www.drsknn.uk/kiosk?tab=treatments';
  var googleMapsUrl = 'https://www.google.com/maps/dir/?api=1&destination=Dr+Sknn,+45+Alderley+Road,+Wilmslow+SK9+1NZ';
  var appleMapsUrl = 'https://maps.apple.com/?daddr=Dr+Sknn,+45+Alderley+Road,+Wilmslow+SK9+1NZ';
  var bookingSelectors = [
    'a[href*="drsknn.uk/kiosk"]',
    'a[href*="drsknn.com/kiosk"]',
    'a[href*="connect-uk1.pabau.me/bookings.php"]',
    'a[href*="connect.pabau.com/bookings.php"]',
    'a[href*="partner.pabau.com/online-bookings/drsknn"]',
    '[onclick*="drsknn.uk/kiosk"]',
    '[onclick*="drsknn.com/kiosk"]',
    '[onclick*="pabau"]'
  ].join(',');
  var textReplacements = [
    [new RegExp(['BOOK', 'A', 'FREE', 'CONSULTATION'].join(' '), 'g'), 'BOOK CONSULTATION'],
    [new RegExp(['BOOK', 'FREE', 'CONSULTATION'].join(' '), 'g'), 'BOOK CONSULTATION'],
    [new RegExp(['BOOK', 'FREE', 'DOCTOR', 'CONSULT'].join(' '), 'g'), 'BOOK CONSULTATION'],
    [/Book Consultation/g, 'Book Consultation'],
    [/Free Doctor Consultation/g, 'Doctor-led planning'],
    [/Free doctor consultation/g, 'Doctor-led planning'],
    [/free doctor consultation/g, 'doctor-led planning'],
    [/free doctor-led consultation/g, 'doctor-led planning']
  ];

  function isOriginDirectConsultationUrl(href) {
    return Boolean(href && href.indexOf('/kiosk/origin/consultation/') !== -1);
  }

  function bookingSignal(element, href) {
    return [
      href || '',
      element && element.textContent ? element.textContent : '',
      element && element.getAttribute ? element.getAttribute('aria-label') || '' : '',
      element && element.getAttribute ? element.getAttribute('onclick') || '' : ''
    ].join(' ').toLowerCase();
  }

  function preferredBookingUrl(element, href) {
    var signal = bookingSignal(element, href);
    if (signal.indexOf('tab=consultations') !== -1 || signal.indexOf('consult') !== -1) {
      return consultationBookingUrl;
    }
    return treatmentBookingUrl;
  }

  function normaliseBookingUrl(href, element) {
    if (!href) return preferredBookingUrl(element, href);
    if (isOriginDirectConsultationUrl(href)) return href;
    if (
      href.indexOf('drsknn.uk/kiosk') !== -1 ||
      href.indexOf('drsknn.com/kiosk') !== -1 ||
      href.indexOf('pabau') !== -1
    ) {
      return preferredBookingUrl(element, href);
    }
    return href;
  }

  function closeOriginModalsBeforeBooking() {
    if (typeof window.drSknnCloseOriginModalsForBooking === 'function') {
      window.drSknnCloseOriginModalsForBooking();
      return;
    }

    var originRoot = document.querySelector('[data-origin-campaign]');
    if (!originRoot) return;

    var openModals = originRoot.querySelectorAll('[data-origin-modal].is-open');
    if (!openModals.length) return;

    openModals.forEach(function (modal) {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      modal.querySelectorAll('video').forEach(function (video) {
        try {
          video.pause();
        } catch (error) {}
      });
    });

    document.documentElement.style.overflow = '';
    document.body.classList.add('drsknn-origin-booking-launching');
    window.clearTimeout(closeOriginModalsBeforeBooking.cleanupTimer);
    closeOriginModalsBeforeBooking.cleanupTimer = window.setTimeout(function () {
      document.body.classList.remove('drsknn-origin-booking-launching');
    }, 2500);
  }

  function normaliseBookingLinks() {
    document.querySelectorAll(bookingSelectors).forEach(function (element) {
      if (element.tagName === 'A') {
        element.setAttribute('href', normaliseBookingUrl(element.getAttribute('href'), element));
      }
      if (!element.dataset.drsknnBookingNormalised) {
        element.dataset.drsknnBookingNormalised = 'true';
      }
    });
  }

  function cleanTextValue(value) {
    var cleaned = value;
    textReplacements.forEach(function (replacement) {
      cleaned = cleaned.replace(replacement[0], replacement[1]);
    });
    return cleaned;
  }

  function shouldSkipTextNode(node) {
    var parent = node.parentElement;
    if (!parent) return true;
    return /^(SCRIPT|STYLE|NOSCRIPT|TEMPLATE|TEXTAREA)$/i.test(parent.tagName);
  }

  function normaliseVisibleCopy(root) {
    var scope = root || document.body;
    if (!scope) return;

    if (scope.nodeType === 3) {
      if (!shouldSkipTextNode(scope)) {
        scope.nodeValue = cleanTextValue(scope.nodeValue);
      }
      return;
    }

    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return shouldSkipTextNode(node) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      }
    });
    var textNode = walker.nextNode();
    while (textNode) {
      textNode.nodeValue = cleanTextValue(textNode.nodeValue);
      textNode = walker.nextNode();
    }
  }

	  function runNormalisers(root) {
	    normaliseBookingLinks();
	    normaliseVisibleCopy(root || document.body);
	    removeVersionedLandingEnhancements();
	    injectEnhancement();
	    wireMapsLinks(root || document.body);
	    wirePricingLinks();
	    injectSchema();
	  }

	  function preferredMapsUrl() {
	    return /Mac|iPhone|iPad|iPod/i.test(window.navigator.userAgent || '') ? appleMapsUrl : googleMapsUrl;
	  }

	  function wireMapsLinks(root) {
	    var mapsUrl = preferredMapsUrl();
	    var scope = root || document.body;
	    if (!scope) return;

	    scope.querySelectorAll('[data-drsknn-maps-link]').forEach(function (link) {
	      link.href = mapsUrl;
	      link.target = '_blank';
	      link.rel = 'noopener';
	    });
	  }

	  function wirePricingLinks() {
	    document.querySelectorAll('[data-drsknn-pricing-link]').forEach(function (link) {
	      if (link.dataset.drsknnPricingLinked) return;
	      link.dataset.drsknnPricingLinked = 'true';
	      link.addEventListener('click', function (event) {
	        if (typeof window.openDrSknnPricingModal !== 'function') return;
	        event.preventDefault();
	        window.openDrSknnPricingModal('', link);
	      });
	    });
	  }

  function watchDynamicContent() {
    var timer = null;
    if (!window.MutationObserver || !document.body) return;
    new MutationObserver(function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        runNormalisers(document.body);
      }, 80);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function pageContext() {
    var path = window.location.pathname || '';
    var handle = path.toLowerCase();
    var title = (document.querySelector('h1') && document.querySelector('h1').textContent.trim()) || document.title.replace(/\s+[-|].*$/, '').trim() || 'Dr Sknn';
    var descriptionMeta = document.querySelector('meta[name="description"]');
    var description = descriptionMeta ? descriptionMeta.getAttribute('content') : '';
    var areaMap = {
      'greater-manchester': 'Greater Manchester',
      'south-manchester': 'South Manchester',
      'alderley-edge': 'Alderley Edge',
      'over-alderley': 'Over Alderley',
      'cheadle-hulme': 'Cheadle Hulme',
      'little-bollington': 'Little Bollington',
      'marple-bridge': 'Marple Bridge',
      'pott-shrigley': 'Pott Shrigley',
      'west-didsbury': 'West Didsbury',
      'east-didsbury': 'East Didsbury',
      'bucklow-hill': 'Bucklow Hill',
      'hale-barns': 'Hale Barns',
      'hazel-grove': 'Hazel Grove',
      'heald-green': 'Heald Green',
      'monks-heath': 'Monks Heath',
      'north-rode': 'North Rode',
      'old-trafford': 'Old Trafford',
      'rode-heath': 'Rode Heath',
      'whiteley-green': 'Whiteley Green',
      'timbersbrook': 'Timbersbrook',
      'alderley': 'Alderley',
      'altrincham': 'Altrincham',
      'bollington': 'Bollington',
      'bolton': 'Bolton',
      'bramhall': 'Bramhall',
      'bredbury': 'Bredbury',
      'cheadle': 'Cheadle',
      'chelford': 'Chelford',
      'cheshire': 'Cheshire',
      'chester': 'Chester',
      'chorlton': 'Chorlton',
      'congleton': 'Congleton',
      'crewe': 'Crewe',
      'didsbury': 'Didsbury',
      'disley': 'Disley',
      'eccles': 'Eccles',
      'golborne': 'Golborne',
      'goostrey': 'Goostrey',
      'hale': 'Hale',
      'handforth': 'Handforth',
      'henbury': 'Henbury',
      'hindley': 'Hindley',
      'hyde': 'Hyde',
      'knutsford': 'Knutsford',
      'liverpool': 'Liverpool',
      'lymm': 'Lymm',
      'macclesfield': 'Macclesfield',
      'manchester': 'Manchester',
      'marple': 'Marple',
      'marton': 'Marton',
      'mere': 'Mere',
      'middlewich': 'Middlewich',
      'middlewood': 'Middlewood',
      'mobberley': 'Mobberley',
      'plumley': 'Plumley',
      'poynton': 'Poynton',
      'prestbury': 'Prestbury',
      'romiley': 'Romiley',
      'royton': 'Royton',
      'sale': 'Sale',
      'salford': 'Salford',
      'sandbach': 'Sandbach',
      'sheffield': 'Sheffield',
      'shevington': 'Shevington',
      'sk9': 'SK9',
      'somerford': 'Somerford',
      'stockport': 'Stockport',
      'stretford': 'Stretford',
      'styal': 'Styal',
      'tabley': 'Tabley',
      'timperley': 'Timperley',
      'tytherington': 'Tytherington',
      'wardsend': 'Wardsend',
      'warford': 'Warford',
      'warrington': 'Warrington',
      'wilmslow': 'Wilmslow',
      'withington': 'Withington',
      'woodley': 'Woodley',
      'wythenshawe': 'Wythenshawe',
      'astle': 'Astle'
    };
    var area = '';
    Object.keys(areaMap).some(function (slug) {
      if (handle.indexOf('-' + slug) !== -1 || handle.indexOf('/' + slug) !== -1) {
        area = areaMap[slug];
        return true;
      }
      return false;
    });
    var family = title;
    if (/botox|anti-wrinkle|forehead-wrinkle|frown-line|crow-s-feet|gummy-smile|sweating/.test(handle)) {
      family = 'Anti-wrinkle injections and line-softening planning';
    } else if (/filler|nasolabial|marionette|tear-trough|jawline|chin|cheek/.test(handle)) {
      family = 'Dermal filler and facial balancing planning';
    } else if (/laser|co2|ipl/.test(handle)) {
      family = 'Laser and device-led skin treatment planning';
    } else if (/hydrafacial|microneedling|chemical-peel|skin-booster|polynucleotide|exosome/.test(handle)) {
      family = 'Skin quality and regenerative treatment planning';
    } else if (/hair-loss|baldness|alopecia|scalp/.test(handle)) {
      family = 'Hair and scalp treatment planning';
    } else if (/fat-reduction|body-contouring|cellulite|hifu|onda/.test(handle)) {
      family = 'Body contouring and skin tightening planning';
    }
    var isVersionedLandingPage = /\/pages\/dr-sknn-landing-v/.test(handle);
    return {
      path: path,
      handle: handle,
      title: title,
      description: description,
      area: area,
      family: family,
      isVersionedLandingPage: isVersionedLandingPage,
      eligible: handle.indexOf('/pages/') === 0 &&
        !isVersionedLandingPage &&
        !/\/pages\/(include-|copy-of-|untitled-)/.test(handle) &&
        !/policy|terms|copywrite|wishlist|compare/.test(handle)
    };
  }

  function removeVersionedLandingEnhancements() {
    if (!pageContext().isVersionedLandingPage) return;
    document.querySelectorAll('.drsknn-seo-enhancement').forEach(function (section) {
      section.remove();
    });
  }

  function injectEnhancement() {
    var context = pageContext();
    if (!context.eligible || document.querySelector('.drsknn-seo-enhancement')) return;
    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main) return;

    var section = document.createElement('section');
    section.className = 'drsknn-seo-enhancement';
    section.setAttribute('aria-labelledby', 'drsknn-seo-enhancement-title');
    section.innerHTML =
      '<div class="page-width">' +
        '<div class="drsknn-seo-enhancement__grid">' +
          '<div class="drsknn-seo-enhancement__main">' +
            '<p class="drsknn-seo-enhancement__label">Doctor-led planning</p>' +
            '<h2 id="drsknn-seo-enhancement-title">Start with the right clinical plan</h2>' +
            '<p>Use this page to understand the options, then choose doctor, nurse or practitioner availability in the booking kiosk. Your clinician will confirm suitability, pricing, expected downtime and aftercare before treatment.</p>' +
            '<div class="drsknn-seo-enhancement__actions">' +
              '<a class="drsknn-seo-enhancement__button drsknn-seo-enhancement__button--primary" href="' + consultationBookingUrl + '">Book Consultation</a>' +
              '<a class="drsknn-seo-enhancement__button drsknn-seo-enhancement__button--secondary" href="' + googleMapsUrl + '" data-drsknn-maps-link target="_blank" rel="noopener">Get Directions</a>' +
            '</div>' +
          '</div>' +
          '<aside class="drsknn-seo-enhancement__panel" aria-label="Consultation options">' +
            '<h3>Consultation options</h3>' +
            '<p>Doctor consultations are £50. Nurse and practitioner consultations are currently free. Fees are shown before booking.</p>' +
            '<dl><div><dt>Clinic</dt><dd><a href="' + googleMapsUrl + '" data-drsknn-maps-link target="_blank" rel="noopener">45 Alderley Road, Wilmslow, SK9 1NZ</a></dd></div><div><dt>Phone</dt><dd><a href="tel:+441625520300">01625 520 300</a></dd></div></dl>' +
          '</aside>' +
        '</div>' +
        '<div class="drsknn-seo-enhancement__trust" aria-label="Why patients choose Dr Sknn">' +
          '<div><strong>Doctor-led</strong><span>Plans are built around suitability, history and realistic outcomes.</span></div>' +
          '<div><strong>Clear pricing</strong><span>Fees and treatment options are shown before you commit to booking.</span></div>' +
          '<div><strong>Aftercare explained</strong><span>Recovery, downtime and maintenance are discussed before treatment.</span></div>' +
          '<div><strong>Wilmslow &amp; Didsbury</strong><span>Clinic routes serving Cheshire, Greater Manchester and named regional searches.</span></div>' +
        '</div>' +
        (context.area && context.area !== 'Wilmslow' ? '<div class="drsknn-seo-enhancement__local"><h2>Visiting Dr Sknn from ' + context.area + '</h2><p>Dr Sknn welcomes patients from ' + context.area + ' through the Wilmslow and Didsbury clinic routes. The booking kiosk lets you compare appointment types before choosing the most suitable consultation route.</p></div>' : '') +
        '<div class="drsknn-seo-enhancement__cards" aria-label="Useful next steps">' +
          '<a href="/pages/consultation-standards"><strong>Consultation standards</strong><span>How we assess suitability, medical history and treatment planning.</span></a>' +
	          '<a href="/pages/pricing" data-drsknn-pricing-link><strong>Price list</strong><span>Compare treatment families before you book your visit.</span></a>' +
          '<a href="/pages/aftercare-standards"><strong>Aftercare standards</strong><span>Understand recovery, downtime and maintenance expectations.</span></a>' +
          '<a href="/skinanalysis"><strong>Free skin analysis</strong><span>Start with guided skin insight before your appointment.</span></a>' +
        '</div>' +
        '<div class="drsknn-seo-enhancement__faq" aria-labelledby="drsknn-seo-faq-title">' +
          '<h2 id="drsknn-seo-faq-title">Common questions</h2>' +
          '<details><summary>What is doctor-led planning?</summary><p>It is a consultation-led approach where your goals, medical history, suitability, treatment options, recovery and aftercare are reviewed before a plan is confirmed.</p></details>' +
          '<details><summary>How much is a consultation?</summary><p>Doctor consultations are £50. Nurse and practitioner consultations are currently free. Fees are shown before booking.</p></details>' +
          '<details><summary>Can I book without knowing which treatment I need?</summary><p>Yes. You can start with a consultation and the team will guide you through suitable options for your skin, face, body or hair goals.</p></details>' +
          '<details><summary>Are results guaranteed?</summary><p>No. Results vary between individuals. Your clinician will explain realistic expectations, risks, downtime and maintenance before treatment.</p></details>' +
        '</div>' +
      '</div>';
    main.appendChild(section);
  }

  function injectSchema() {
    var context = pageContext();
    if (!context.eligible || document.getElementById('drsknn-js-schema')) return;
    if (document.documentElement.innerHTML.indexOf('https://drsknn.com/#wilmslow-clinic') !== -1) return;
    var url = 'https://drsknn.com' + context.path;
    var schema = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Organization',
          '@id': 'https://drsknn.com/#organization',
          name: 'Dr Sknn',
          url: 'https://drsknn.com',
          description: 'Doctor-led medical aesthetics clinic providing consultation-led skin, face, body and hair treatment planning through Wilmslow and Didsbury clinic routes.',
          telephone: '+441625520300',
          email: 'hello@drsknn.com'
        },
        {
          '@type': 'MedicalBusiness',
          '@id': 'https://drsknn.com/#wilmslow-clinic',
          name: 'Dr Sknn Wilmslow',
          url: 'https://drsknn.com',
          parentOrganization: { '@id': 'https://drsknn.com/#organization' },
          telephone: '+441625520300',
          email: 'hello@drsknn.com',
          priceRange: '££',
          address: {
            '@type': 'PostalAddress',
            streetAddress: '45 Alderley Road',
            addressLocality: 'Wilmslow',
            addressRegion: 'Cheshire',
            postalCode: 'SK9 1NZ',
            addressCountry: 'GB'
          },
          areaServed: ['Wilmslow', 'Didsbury', 'Cheshire', 'Greater Manchester', 'South Manchester', 'Alderley Edge', 'Over Alderley', 'Prestbury', 'Handforth', 'Styal', 'Cheadle', 'Cheadle Hulme', 'Bramhall', 'Hale', 'Hale Barns', 'Altrincham', 'Timperley', 'Sale', 'Chorlton', 'Withington', 'Stockport', 'Poynton', 'Marple', 'Marple Bridge', 'Macclesfield', 'Knutsford', 'Rode Heath', 'North Rode', 'Marton', 'Warrington', 'Chester', 'Liverpool', 'Sheffield'],
          medicalSpecialty: ['Aesthetic medicine', 'Skin rejuvenation', 'Hair restoration', 'Regenerative aesthetics']
        },
        {
          '@type': 'MedicalBusiness',
          '@id': 'https://drsknn.com/#didsbury-clinic',
          name: 'Dr Sknn Didsbury',
          url: 'https://drsknn.com',
          parentOrganization: { '@id': 'https://drsknn.com/#organization' },
          telephone: '+441625520300',
          email: 'hello@drsknn.com',
          priceRange: '££',
          address: {
            '@type': 'PostalAddress',
            streetAddress: 'Sterling Pharmacy, 103 Lapwing Lane',
            addressLocality: 'Didsbury',
            addressRegion: 'Manchester',
            postalCode: 'M20 6UR',
            addressCountry: 'GB'
          },
          areaServed: ['Didsbury', 'West Didsbury', 'East Didsbury', 'South Manchester', 'Withington', 'Chorlton', 'Cheadle', 'Stockport', 'Greater Manchester'],
          medicalSpecialty: ['Aesthetic medicine', 'Skin rejuvenation', 'Hair restoration', 'Regenerative aesthetics']
        },
        {
          '@type': 'WebPage',
          '@id': url + '#webpage',
          url: url,
          name: context.title,
          description: context.description,
          about: { '@id': 'https://drsknn.com/#organization' },
          mentions: [{ '@id': 'https://drsknn.com/#wilmslow-clinic' }, { '@id': 'https://drsknn.com/#didsbury-clinic' }]
        },
        {
          '@type': 'BreadcrumbList',
          '@id': url + '#breadcrumb',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://drsknn.com' },
            { '@type': 'ListItem', position: 2, name: context.title, item: url }
          ]
        },
        {
          '@type': 'Service',
          '@id': url + '#service',
          name: context.family,
          serviceType: context.family,
          provider: { '@id': 'https://drsknn.com/#organization' },
          areaServed: context.area || 'Cheshire and Greater Manchester',
          hasOfferCatalog: {
            '@type': 'OfferCatalog',
            name: 'Consultation options',
            itemListElement: [
              { '@type': 'Offer', name: 'Doctor-led planning consultation', price: '50', priceCurrency: 'GBP', availability: 'https://schema.org/InStock', url: consultationBookingUrl },
              { '@type': 'Offer', name: 'Nurse consultation', price: '0', priceCurrency: 'GBP', availability: 'https://schema.org/InStock', url: consultationBookingUrl },
              { '@type': 'Offer', name: 'Practitioner consultation', price: '0', priceCurrency: 'GBP', availability: 'https://schema.org/InStock', url: consultationBookingUrl }
            ]
          }
        },
        {
          '@type': 'FAQPage',
          '@id': url + '#consultation-faq',
          mainEntity: [
            { '@type': 'Question', name: 'What is the first step at Dr Sknn?', acceptedAnswer: { '@type': 'Answer', text: 'Start with doctor-led planning so the team can understand your goals, medical history, suitability, treatment options, downtime and aftercare before confirming a plan.' } },
            { '@type': 'Question', name: 'How much is a consultation?', acceptedAnswer: { '@type': 'Answer', text: 'Doctor consultations are £50. Nurse and practitioner consultations are currently free. Fees are shown before booking.' } },
            { '@type': 'Question', name: 'Where is Dr Sknn located?', acceptedAnswer: { '@type': 'Answer', text: 'Dr Sknn is anchored by the Wilmslow clinic at 45 Alderley Road, Wilmslow, SK9 1NZ, with Didsbury clinic access at Sterling Pharmacy, 103 Lapwing Lane, Didsbury, M20 6UR.' } },
            { '@type': 'Question', name: 'Are treatment results guaranteed?', acceptedAnswer: { '@type': 'Answer', text: 'No. Results vary between individuals. Your clinician will explain realistic expectations, suitability, risks, aftercare and possible maintenance during consultation.' } }
          ]
        }
      ]
    };
    var script = document.createElement('script');
    script.id = 'drsknn-js-schema';
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest(bookingSelectors) : null;
    if (!link) return;

    var bookingUrl = normaliseBookingUrl(link.getAttribute('href'));
    if (link.tagName === 'A') {
      link.setAttribute('href', bookingUrl);
    }

    if (link.hasAttribute('data-drsknn-direct-booking') || isOriginDirectConsultationUrl(bookingUrl)) {
      closeOriginModalsBeforeBooking();
      return;
    }

    if (typeof window.openPabauModal === 'function') {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
      closeOriginModalsBeforeBooking();
      window.openPabauModal(bookingUrl);
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      runNormalisers(document.body);
      watchDynamicContent();
    });
  } else {
    runNormalisers(document.body);
    watchDynamicContent();
  }
})();
